import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';
import { invalidateEntitlements } from '../../../hooks/useEntitlements';

export default function MembershipSuccessPage() {
  const { t } = useTranslation('membership');

  // The checkout that lands here can unlock «مؤشرات السوق»: make the next access
  // check skip the cached answer (client store and the server's 60 s cache).
  useEffect(() => {
    invalidateEntitlements();
  }, []);

  // The keys are top-level in the membership namespace; the old
  // `membership.*` paths printed the raw key names. The old Stripe `session_id`
  // line is gone: payments go through Moyasar, and that copy names Stripe.
  const sessionSummary = t('checkoutCompleted');

  return (
    <div className="min-h-screen bg-white text-slate-700">
      <Navigation />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-xl shadow-md p-8 text-center">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
            <i className="ri-check-line text-3xl text-green-600"></i>
          </div>

          <h1 className="text-3xl font-bold text-[var(--pv-color-primary)] mb-4">
            {t('successTitle')}
          </h1>
          <p className="text-gray-600 mb-6">
            {sessionSummary}
          </p>

          <div className="space-y-3">
            <p className="text-sm text-gray-500">
              {t('successDetails')}
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Button
                onClick={() => window.location.replace('/profile')}
                size="lg"
              >
                <i className="ri-user-line me-2"></i>
                {t('goToProfile')}
              </Button>
              <Link
                to="/billing"
                className="inline-flex items-center justify-center rounded-lg border border-[#004D40] px-6 py-3 text-sm font-medium text-[#003930] transition-colors hover:bg-[var(--pv-color-surface-sunken)]"
              >
                <i className="ri-receipt-line me-2"></i>
                {t('billing:pageTitle', { defaultValue: 'Payments & Invoices' })}
              </Link>
              <Link
                to="/membership"
                className="inline-flex items-center justify-center rounded-lg border border-[#004D40] px-6 py-3 text-sm font-medium text-[#003930] transition-colors hover:bg-[var(--pv-color-surface-sunken)]"
              >
                {t('returnToMemberships')}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
